import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootReducer } from "../app/reducer";
import { Link } from "react-router-dom";

const Disclaimer: React.FC = () => {
  // this is used for the whole app
  const disclaimerAccepted = useSelector((state: RootReducer) => {
    //        console.log("disclaimer index.tsx DISCLAIMER ACCEPTED GET: " + JSON.stringify(state));
    return state.appReducer.blnAppDisclaimerAgreed;
  });

  // this is only used in the disclaimer
  const disclaimerRejected = useSelector((state: RootReducer) => {
    //        console.log("disclaimer index.tsx DISCLAIMER REJECTED GET: " + JSON.stringify(state));
    //console.log("disclaimer index.tsx get disclaimer rejected state is  " + JSON.stringify(state))
    return state.appReducer.blnAppDisclaimerRejected;
  });

  const dispatchDisclaimer = useDispatch();

  return (
    <div>
      {!disclaimerAccepted && !disclaimerRejected && (
        <>
          <p className="justified">
            Clearstream makes every effort to ensure that the information
            provided herein is correct but does not guarantee its accuracy or
            completeness. This database of securities is a non-exhaustive one
            that neither covers all securities eligible in Clearstream's system
            nor provides all details related to securities listed in.
            Clearstream accepts no liability for any loss or damage of any type
            resulting from errors herein. No part of this document may be
            reproduced or transmitted in any form or by any means, electronic or
            mechanical, including photocopying and recording, for any purpose
            without the express written consent of Clearstream.
          </p>
          <p className="disclaimer-header bold">
            US Withholding Tax Regulations
          </p>
          <p className="justified">
            For the securities identified as being subject to the US Internal
            Revenue Code Section 1441 US withholding regulations (NRA),
            effective 1&nbsp;January&nbsp;2001, and/or being subject to the US
            Internal Revenue Code Section 1471 US withholding regulations
            (FATCA), effective 1&nbsp;July&nbsp;2014, Clearstream does not
            guarantee the accuracy or completeness of the information provided,
            which is given only for the purpose of assisting customers in
            preparing for the application of the US withholding regulations.
            Consequently, Clearstream cannot be held responsible or liable for
            any loss, costs, taxes or penalties incurred as a result of
            customers' reliance on this information.
          </p>
          <p className="disclaimer-header bold">
            Italian Witholding Tax Regulation
          </p>
          <p className="justified">
            Italian Eurobonds are Italian bonds and similar instruments subject
            to Legislative Decree n.239/1996 and atypical instruments not
            subject to Legislative Decree n.239/1996 that are issued outside
            Italy by Italian banks and Italian companies whose shares are listed
            on an Italian regulated market. For these particular securities,
            Clearstream does not guarantee the accuracy or completeness of the
            information provided, which is given only for the purpose of
            assisting customers in preparing for the application of Italian
            withholding tax regulations: Consequently, Clearstream cannot be
            held responsible or liable for any loss, costs, taxes or penalties
            incurred as a result of customers' reliance on this information.
          </p>          
          <br />
          <p className="justified">
            Clearstream refers to (i) Clearstream Banking S.A. registered office
            at 42, avenue John F. Kennedy, L-1855 Luxembourg and registered with
            the Luxembourg Trade and Companies Register under number B-9248 and
            (ii) Clearstream Europe AG with registered office at 61,
            Mergenthalerallee, 65760 Eschborn, Germany and registered in
            Register B of the Amtsgericht Frankfurt am Main, Germany under
            number HRB 7500.
          </p>

          <div>
            <div>
              <span className="disclaimer-option">
                <button
                  onClick={() =>
                    dispatchDisclaimer({ type: "App/DISCLAIMERACCEPT" })
                  }
                >
                  I Agree
                </button>
              </span>
              <span className="disclaimer-option">
                <button
                  onClick={() =>
                    dispatchDisclaimer({ type: "App/DISCLAIMERREJECT" })
                  }
                >
                  I disagree
                </button>
              </span>
            </div>
            <div className="disclaimer-note">
              <span className="small">
                Please make sure that the cookies in your browser are enabled,
                otherwise a connection is not possible.
              </span>
            </div>
          </div>
        </>
      )}
      {disclaimerRejected && (
        <>
          <p>
            We are sorry, but access to the information is not allowed unless
            you accept the conditions described on the previous page.
          </p>
          <p>
            Press{" "}
            <Link to="/queries" className="navigation">
              here
            </Link>{" "}
            to go back to the Legal Conditions or go back to the Clearstream web
            site.
          </p>
        </>
      )}
      {disclaimerAccepted && null}
    </div>
  );
};

export default Disclaimer;
